import { useEffect, useState } from "react";
import type { PageType } from "../utils/albumData";
import Slider from "@mui/material/Slider";

export default function PageManagerPanel({
    show,
    pages,
    selectedPageId,
  //  setSelectedPageId,
    setShowPageManager,
    onApply,
    thumbnails,
    stageWidth,
    stageHeight,
}: any) {

    const [tempPages, setTempPages] = useState<PageType[]>(pages);
    const [selectedPages, setSelectedPages] = useState<string[]>([]);
    const [zoom, setZoom] = useState(1);

    const hasChanges = JSON.stringify(tempPages) !== JSON.stringify(pages);

    useEffect(() => {
        setTempPages(pages);
    }, [pages, show]);

    useEffect(() => {
        if (!show) return;
        setSelectedPages([]);
    }, [show]);

    //  ONLY AFTER hooks
    if (!show) return null;


    const movePage = (from: number, to: number) => {
        setTempPages(prev => {
            const copy = [...prev];
            const [removed] = copy.splice(from, 1);
            copy.splice(to, 0, removed);
            return copy;
        });
    };

    const handleApply = () => {
        onApply(tempPages);
        setShowPageManager(false);
    };
  

    const PREVIEW_WIDTH = 220;
    const pageAR = stageWidth / stageHeight;
    const previewHeight = PREVIEW_WIDTH / pageAR;
 
   
    return (
        <div
            onClick={() => setShowPageManager(false)}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 20,
            }}
        >
            {/* PANEL */}
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "82vw",
                    height: "94vh",
                    background: "#ffffff",
                    borderRadius: 12,

                    //  BLUE BORDER STYLE
                    border: "2px solid #4a90e2",
                    boxShadow: "0 10px 35px rgba(0,0,0,0.25)",

                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                {/* HEADER */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 14px",
                        borderBottom: "1px solid #e5e5e5",
                        background: "#f7fbff",
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            minWidth: 0,
                            marginRight: 20,
                        }}
                    >
                        <div
                            style={{
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#1f2d3d",
                                marginBottom: 4,
                            }}
                        >
                            Spread Manager
                        </div>

                        <div
                            style={{
                                fontSize: 14,
                                color: "#555",
                            }}
                        >
                            Rearrange spreads by dragging them..
                           Select spreads (Ctrl/Cmd + click for multiple selection, Shift + click for range selection) and delete the ones you do not need.
                            Click Apply to save your changes.
                        </div>
                    </div>

                    <button
                        onClick={() => {
                            setTempPages(prev =>
                                prev.filter(p => !selectedPages.includes(p.id))
                            );
                            setSelectedPages([]);
                        }}
                        disabled={selectedPages.length === 0}
                        style={{
                            padding: "6px 12px",
                            borderRadius: 6,
                            border: "1px solid #d9534f",
                            background: "#fff",
                            color: "#d9534f",
                            fontWeight: 600,
                            cursor: selectedPages.length === 0 ? "not-allowed" : "pointer",
                            flexShrink: 0,
                        }}
                    >
                        Delete ({selectedPages.length})
                    </button>

                    <div
                        style={{
                            display: "flex",
                            gap: 8,
                            flexShrink: 0,
                            marginLeft: 10,
                        }}
                    >
                        <button
                            onClick={() => setShowPageManager(false)}
                            style={{
                                padding: "6px 10px",
                                borderRadius: 6,
                                border: "1px solid #ccc",
                                background: "#fff",
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>

                        <button
                            onClick={handleApply}
                            disabled={!hasChanges}
                            style={{
                                padding: "6px 12px",
                                borderRadius: 6,
                                border: "none",
                                background: !hasChanges ? "#cfe3ff" : "#4a90e2",
                                color: "#fff",
                                fontWeight: 600,
                                cursor: !hasChanges ? "not-allowed" : "pointer",
                                opacity: !hasChanges ? 0.6 : 1,
                            }}
                        >
                            Apply
                        </button>

                    </div>
                </div>

                {/* GRID */}
                <div
                    style={{
                        flex: 1,
                        overflow: "auto",
                        padding: 14,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 14,
                        background: "#e7e7e7",
                        alignContent: "flex-start",
                    }}
                    onClick={() => setSelectedPages([])}
                >
                    {tempPages.map((page: any, index: number) => {
                        const isSelected = selectedPages.includes(page.id);

                        return (
                            <div
                                key={page.id}
                                draggable
                                onDragStart={(e) =>
                                    e.dataTransfer.setData("from", index.toString())
                                }
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={(e) => {
                                    const from = Number(e.dataTransfer.getData("from"));
                                    movePage(from, index);
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();

                                    const isMultiSelect = e.ctrlKey || e.metaKey;
                                    const isRangeSelect = e.shiftKey;

                                    setSelectedPages((prev) => {
                                        // Shift-click = select range
                                        if (isRangeSelect && prev.length > 0) {
                                            const lastSelectedId = prev[prev.length - 1];
                                            const lastSelectedIndex = tempPages.findIndex(
                                                (p: any) => p.id === lastSelectedId
                                            );

                                            if (lastSelectedIndex !== -1) {
                                                const start = Math.min(lastSelectedIndex, index);
                                                const end = Math.max(lastSelectedIndex, index);

                                                const rangeIds = tempPages
                                                    .slice(start, end + 1)
                                                    .map((p: any) => p.id);

                                                return Array.from(new Set([...prev, ...rangeIds]));
                                            }
                                        }

                                        // Ctrl/Cmd-click = toggle selection
                                        if (isMultiSelect) {
                                            if (prev.includes(page.id)) {
                                                return prev.filter(id => id !== page.id);
                                            }

                                            return [...prev, page.id];
                                        }

                                        // Normal click = single selection
                                        return [page.id];
                                    });
                                }}
                                style={{
                                    cursor: "grab",
                                    width: PREVIEW_WIDTH * zoom,
                                    background: isSelected ? "#eef6ff" : "#fff",
                                    border: isSelected ? "2px solid #4a90e2" : "2px solid #ddd",
                                 
                                    borderRadius: 8,
                                    padding: 8,
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 6,
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: "#555",
                                        alignSelf: "flex-start",
                                    }}
                                >
                                    Spread {index + 1}
                                </div>

                                <img
                                    src={thumbnails[page.id]}
                                    style={{
                                        width: PREVIEW_WIDTH * zoom,
                                        height: previewHeight * zoom,
                                        objectFit: "contain",
                                        background: "#fff",                                  
                                        display: "block",
                                        border: "2px solid #cfcfcf",
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>


                {/* ZOOM FOOTER */}
                <div
                    style={{
                        height: 45,
                        borderTop: "1px solid #ddd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center", // IMPORTANT (not space-between)
                        background: "#f7fbff",
                    }}
                >
                    {/* GROUP (image + slider + image) */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        {/* LEFT IMAGE (before slider) */}
                        <img
                            src={`${process.env.PUBLIC_URL}/zoom_small.png`}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                width: 37,
                                height: 25,
                                objectFit: "contain",
                                borderRadius: 6,
                                paddingRight:10
                            }}
                        />

                        {/* SLIDER GROUP */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                width: 200, // optional control width
                            }}
                        >
                            <span style={{ fontSize: 14, color: "#555" }}>Zoom</span>

                            <Slider
                                value={zoom}
                                onChange={(_, value) => setZoom(value as number)}
                                min={1}
                                max={2}
                                step={0.25}
                                marks
                                valueLabelDisplay="auto"
                                sx={{
                                    height: 6,
                                    marginTop: -0.5,
                                    width: '100%',
                                    '& .MuiSlider-thumb': { width: 16, height: 16, backgroundColor: "#fff", border: 1 },
                                    '& .MuiSlider-rail': { height: 6, color: "#59b3d8" },
                                    '& .MuiSlider-track': { height: 5, color: "#59b3d8" },

                                }}
                            
                            />
                        </div>

                        {/* RIGHT IMAGE (after slider) */}
                        <img
                            src={`${process.env.PUBLIC_URL}/zoom_big.png`}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                width: 37,
                                height: 25,
                                objectFit: "contain",
                                borderRadius: 6,
                                paddingLeft: 10
                            }}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
}